(function () {
  'use strict';

  var CURRENCIES = [
    { code: 'TRY', symbol: '₺', label: 'TL' },
    { code: 'USD', symbol: '$', label: 'USD' },
    { code: 'EUR', symbol: '€', label: 'EUR' },
    { code: 'SAR', symbol: 'ر.س', label: 'SAR' },
    { code: 'GBP', symbol: '£', label: 'GBP' }
  ];

  var API_URL = 'https://open.er-api.com/v6/latest/TRY';
  var SK = 'dnf_currency';
  var RK = 'dnf_rates';
  var TTL = 3600000;
  var rates = { TRY: 1 };
  var activeCurrency = 'TRY';

  try { activeCurrency = localStorage.getItem(SK) || 'TRY'; } catch(e) {}

  function fetchRates(cb) {
    try {
      var cached = localStorage.getItem(RK);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (Date.now() - parsed.ts < TTL) { rates = parsed.data; cb(); return; }
      }
    } catch(e) {}
    var xhr = new XMLHttpRequest();
    xhr.open('GET', API_URL, true);
    xhr.onload = function() {
      try {
        var json = JSON.parse(xhr.responseText);
        if (json.result === 'success') {
          rates = json.rates;
          try { localStorage.setItem(RK, JSON.stringify({ ts: Date.now(), data: rates })); } catch(e) {}
        }
      } catch(e) {}
      cb();
    };
    xhr.onerror = function() { cb(); };
    xhr.send();
  }

  function parseTL(el) {
    var text = el.textContent.replace(/[^\d.,]/g, '');
    var n = text.replace(/\./g, '').replace(',', '.');
    return parseFloat(n) || null;
  }

  function updatePrices() {
    var existing = document.querySelectorAll('.dnf-cp');
    for (var i = 0; i < existing.length; i++) {
      existing[i].parentNode.removeChild(existing[i]);
    }
    if (activeCurrency === 'TRY') return;

    var cur = null;
    for (var j = 0; j < CURRENCIES.length; j++) {
      if (CURRENCIES[j].code === activeCurrency) { cur = CURRENCIES[j]; break; }
    }
    if (!cur || !rates[activeCurrency]) return;

    var rate = rates[activeCurrency];
    // Dwell theme fiyat selector'ları
    var els = document.querySelectorAll('span.price-item--sale, span.price, [data-product-price], .cart-items__price');
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      var val = parseTL(el);
      if (!val) continue;
      var converted = (val * rate).toFixed(2);
      var badge = document.createElement('span');
      badge.className = 'dnf-cp';
      badge.style.cssText = 'display:inline-block;margin-left:5px;font-size:.8em;color:#888;background:#f5f5f5;border-radius:3px;padding:1px 5px;vertical-align:middle;white-space:nowrap;';
      badge.title = 'Tahmini — ödeme TL ile alınır';
      badge.textContent = '~' + cur.symbol + converted;
      el.parentNode.insertBefore(badge, el.nextSibling);
    }
  }

  function buildWidget() {
    var w = document.createElement('div');
    w.id = 'dnf-currency-widget';
    w.style.cssText = 'position:fixed;bottom:80px;right:16px;z-index:2147483647;background:#fff;border:1px solid #ddd;border-radius:10px;padding:7px 11px;box-shadow:0 2px 14px rgba(0,0,0,.13);display:flex;align-items:center;gap:5px;font-family:sans-serif;font-size:12px;';

    CURRENCIES.forEach(function(c) {
      var btn = document.createElement('button');
      btn.textContent = c.label;
      var isActive = c.code === activeCurrency;
      btn.style.cssText = 'border:1px solid ' + (isActive ? '#C9A96E' : '#ddd') + ';background:' + (isActive ? '#C9A96E' : '#fff') + ';color:' + (isActive ? '#fff' : '#444') + ';border-radius:4px;padding:3px 8px;cursor:pointer;font-size:12px;transition:all .15s;';
      (function(code, b) {
        b.addEventListener('click', function() {
          activeCurrency = code;
          try { localStorage.setItem(SK, code); } catch(e) {}
          var btns = w.querySelectorAll('button');
          for (var i = 0; i < btns.length; i++) {
            btns[i].style.background = '#fff';
            btns[i].style.color = '#444';
            btns[i].style.borderColor = '#ddd';
          }
          b.style.background = '#C9A96E';
          b.style.color = '#fff';
          b.style.borderColor = '#C9A96E';
          updatePrices();
        });
      })(c.code, btn);
      w.appendChild(btn);
    });

    return w;
  }

  function init() {
    if (document.getElementById('dnf-currency-widget')) return;
    var w = buildWidget();
    document.body.appendChild(w);
    fetchRates(function() { updatePrices(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();